const  IsEmpty=(value) =>{
    return (value == null || (typeof value === "string" && value.trim().length === 0));
  }
  const IsEmptyObj = {
    IsEmpty,
  };
  export default IsEmptyObj;